import { render, staticRenderFns } from "./ModalPeriodo.vue?vue&type=template&id=5ea4976e&"
import script from "./ModalPeriodo.vue?vue&type=script&lang=js&"
export * from "./ModalPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports